var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.filtersToDisplay),function(filter,filterIndex){return _c('div',{key:filterIndex},[_c('span',[_vm._v(_vm._s(`${filter.criteria} ${filter.operator} ${filter.value}`))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }